import type { PlanCode } from "../types";

/** 表示名。プラン名は商品名なので翻訳しない（LP・App Store の表記と揃える）。 */
const PLAN_LABELS: Record<PlanCode, string> = {
  free: "Free",
  starter: "Starter",
  pro: "Pro",
  business: "Business",
  enterprise: "Enterprise",
};

/**
 * プラン code の表示名。
 *
 * null（未購読）は **Free** として出す＝backend の上限判定も未購読を free に
 * 落としているので（`entitlements._limit_for`）、画面だけ「プラン未設定」と出すと
 * 実際に効いている上限と食い違う。
 */
export function planLabel(code: PlanCode | null | undefined): string {
  if (!code) return PLAN_LABELS.free;
  return PLAN_LABELS[code] ?? PLAN_LABELS.free;
}
